export class Primary {
  constructor() {
   this.name = 'Primary'
   this.content = {
     text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
     hasTitle: true,
     titleText: 'Title',
     hasIcon: true,
     class: 'fas',
     icon: 'fa-ban',
     isClosable: true
   }
   this.view = this.viewHtml()
  }

  viewHtml() {
    return `<div>primary</div>`
  }

  iconContainerClasses() {
    return [
      {property: 'Rounded', value: 'ROUNDED_LG'},
      {property: 'Size', value: 'SIZE_MD'},
    ]
  }

  iconContainerStyles() {
    return [
      {property:'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg, #f56564, #f56564)'},
    ]
  }

  iconStyles() {
    return [
      {property:'TextColor', styleProperty: 'color', value: '#ffffff'},
    ]
  }

  classes() {
    return [
      {property: 'Rounded', value: 'ROUNDED_NONE'},
      {property: 'Shadow', value: 'SHADOW_MD'},
      {property: 'BorderStyle', value: 'BORDER_SOLID'},
      {property: 'BorderSideTopWidth', value: 'BORDER_TOP_NONE'},
      {property: 'BorderSideBottomWidth', value: 'BORDER_BOTTOM_NONE'},
      {property: 'BorderSideLeftWidth', value: 'BORDER_LEFT_BOLD'},
      {property: 'BorderSideRightWidth', value: 'BORDER_RIGHT_NONE'},
    ]
  }

  styles() {
    return [
      {property:'BorderColor', styleProperty: 'border-color', value: '#f56564'},
      {property:'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg, #fff5f5,#fff5f5)'},
    ]
  }

  buildData() {
    return {
      name: this.name,
      view: this.view,
    }
  }

  editorProperties() {
    return {
      content: this.content,
      classes: {
        desktop: this.classes(),
        tablet: this.classes(),
        phone: this.classes()
      },
      styles: {
        desktop: this.styles(),
        tablet: this.styles(),
        phone: this.styles()
      },
      iconContainerClasses: {
        desktop: this.iconContainerClasses(),
        tablet: this.iconContainerClasses(),
        phone: this.iconContainerClasses()
      },
      iconStyles: {
        desktop: this.iconStyles(),
        tablet: this.iconStyles(),
        phone: this.iconStyles()
      },
      iconContainerStyles: {
        desktop: this.iconContainerStyles(),
        tablet: this.iconContainerStyles(),
        phone: this.iconContainerStyles()
      },
    }
  }
}